export const IMPORTAR_CATALOGO_PROPIO_REQUEST = 'IMPORTAR_CATALOGO_PROPIO_REQUEST';
export const IMPORTAR_CATALOGO_PROPIO_SUCCESS = 'IMPORTAR_CATALOGO_PROPIO_SUCCESS';
export const IMPORTAR_CATALOGO_PROPIO_FAILURE = 'IMPORTAR_CATALOGO_PROPIO_FAILURE';